module.exports = __webpack_public_path__ + "img/bohrungen-2_zzz.58915c08.jpg";